import React from "react";
import { Link } from "react-router-dom";
import { Library } from "lucide-react";
import { Layout } from "../components/layout";

export function BlockPatternsPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Library className="h-6 w-6 text-blue-400" />
          <h1 className="text-3xl font-bold text-white">Block Library</h1>
        </div>

        <div className="flex flex-col items-center justify-center min-h-[400px] rounded-xl bg-slate-800/50 backdrop-blur-xl border border-white/10">
          <p className="text-slate-400 mb-4">No blocks saved yet.</p>
          <Link
            to="/generator"
            className="text-blue-400 hover:text-blue-300 transition-colors"
          >
            Generate some blocks
          </Link>
        </div>
      </div>
    </Layout>
  );
}
